<div class="position-relative f-poppins">
    <app-model-layout-header (closemodellayout)="closemodel($event)"></app-model-layout-header>
    <ng-container  (senddataDetails) ="getdatadetails($event)" *ngComponentOutlet="data.component"></ng-container> 
</div>
